import { Analysis } from '../../../types/Survey/Analysis/Analysis'
import {
  ArbeitsplatzAmountFactorValues,
  FactorValues,
  FactorValueWithOriginal,
  GenericFactorValues,
  GenericQMFactorValues,
} from '../../../types/Survey/Analysis/FactorValues'
import {
  PrebuildArbeitstagSubType,
  PrebuildEinzelarbeitSubType,
  PrebuildMeetingGroesseBesprechungSubType,
  PrebuildMeetingGroesseCoworkingSubType,
  PrebuildType,
} from '../../../types/Survey/Element'
import { Survey } from '../../../types/Survey/Survey'
import getSliderValue from './getSliderValue'

export const getFactorWithOriginal = (value: number): FactorValueWithOriginal => {
  return { value, originalValue: value }
}

export const genericQMValues: GenericQMFactorValues = {
  einzelarbeitQM: {
    [PrebuildEinzelarbeitSubType.KLASSISCHE_ARBEIT]: getFactorWithOriginal(6),
    [PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR]: getFactorWithOriginal(6),
    [PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR]: getFactorWithOriginal(6),
  },
  meetingGroesseBesprechungQM: {
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_2]: getFactorWithOriginal(6),
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_3_4]: getFactorWithOriginal(12),
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_5_8]: getFactorWithOriginal(24),
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_9_12]: getFactorWithOriginal(30),
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_13_16]: getFactorWithOriginal(42),
  },
  meetingGroesseCoworkingQM: {
    [PrebuildMeetingGroesseCoworkingSubType.PERSON_2_4]: getFactorWithOriginal(12),
    [PrebuildMeetingGroesseCoworkingSubType.PERSON_5_8]: getFactorWithOriginal(24),
    [PrebuildMeetingGroesseCoworkingSubType.PERSON_9_12]: getFactorWithOriginal(30),
    [PrebuildMeetingGroesseCoworkingSubType.PERSON_13_16]: getFactorWithOriginal(42),
  },
  einzelbueroQM: getFactorWithOriginal(12),
}

export const arbeitsplatzAmountFactorValues: ArbeitsplatzAmountFactorValues = {
  [PrebuildType.EINZELARBEIT]: {
    [PrebuildEinzelarbeitSubType.KLASSISCHE_ARBEIT]: getFactorWithOriginal(1),
    [PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR]: getFactorWithOriginal(1),
    [PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR]: getFactorWithOriginal(1),
  },
  [PrebuildType.MEETING_GROESSE_BESPRECHUNG]: {
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_2]: getFactorWithOriginal(1),
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_3_4]: getFactorWithOriginal(1),
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_5_8]: getFactorWithOriginal(2),
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_9_12]: getFactorWithOriginal(4),
    [PrebuildMeetingGroesseBesprechungSubType.PERSON_13_16]: getFactorWithOriginal(6),
  },
  [PrebuildType.MEETING_GROESSE_COWORKING]: {
    [PrebuildMeetingGroesseCoworkingSubType.PERSON_2_4]: getFactorWithOriginal(1),
    [PrebuildMeetingGroesseCoworkingSubType.PERSON_5_8]: getFactorWithOriginal(2),
    [PrebuildMeetingGroesseCoworkingSubType.PERSON_9_12]: getFactorWithOriginal(4),
    [PrebuildMeetingGroesseCoworkingSubType.PERSON_13_16]: getFactorWithOriginal(6),
  },
}

export const genericFactorValues: GenericFactorValues = {
  locker: getFactorWithOriginal(0.075),
  drucker: getFactorWithOriginal(0.15),
  workcafe: getFactorWithOriginal(1),
  garderobe: getFactorWithOriginal(0.036),
}

const getFactorValues = (survey: Survey, analysis: Analysis): FactorValues => {
  return {
    ...genericQMValues,
    ...genericFactorValues,
    arbeitsplatz: arbeitsplatzAmountFactorValues,
    arbeitstagPercentage: {
      [PrebuildArbeitstagSubType.EINZELARBEIT]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.ARBEITSTAG, PrebuildArbeitstagSubType.EINZELARBEIT).average,
      ),
      [PrebuildArbeitstagSubType.KOMMUNIKATION]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.ARBEITSTAG, PrebuildArbeitstagSubType.KOMMUNIKATION).average,
      ),
      [PrebuildArbeitstagSubType.KOLLABORATION]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.ARBEITSTAG, PrebuildArbeitstagSubType.KOLLABORATION).average,
      ),
    },
    einzelarbeitPercentage: {
      [PrebuildEinzelarbeitSubType.KLASSISCHE_ARBEIT]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.EINZELARBEIT, PrebuildEinzelarbeitSubType.KLASSISCHE_ARBEIT).average,
      ),
      [PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.EINZELARBEIT, PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR).average,
      ),
      [PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.EINZELARBEIT, PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR).average,
      ),
    },
    meetingGroesseBesprechungPercentage: {
      [PrebuildMeetingGroesseBesprechungSubType.PERSON_2]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_BESPRECHUNG, PrebuildMeetingGroesseBesprechungSubType.PERSON_2).average,
      ),
      [PrebuildMeetingGroesseBesprechungSubType.PERSON_3_4]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_BESPRECHUNG, PrebuildMeetingGroesseBesprechungSubType.PERSON_3_4).average,
      ),
      [PrebuildMeetingGroesseBesprechungSubType.PERSON_5_8]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_BESPRECHUNG, PrebuildMeetingGroesseBesprechungSubType.PERSON_5_8).average,
      ),
      [PrebuildMeetingGroesseBesprechungSubType.PERSON_9_12]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_BESPRECHUNG, PrebuildMeetingGroesseBesprechungSubType.PERSON_9_12).average,
      ),
      [PrebuildMeetingGroesseBesprechungSubType.PERSON_13_16]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_BESPRECHUNG, PrebuildMeetingGroesseBesprechungSubType.PERSON_13_16).average,
      ),
    },
    meetingGroesseCoworkingPercentage: {
      [PrebuildMeetingGroesseCoworkingSubType.PERSON_2_4]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_COWORKING, PrebuildMeetingGroesseCoworkingSubType.PERSON_2_4).average,
      ),
      [PrebuildMeetingGroesseCoworkingSubType.PERSON_5_8]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_COWORKING, PrebuildMeetingGroesseCoworkingSubType.PERSON_5_8).average,
      ),
      [PrebuildMeetingGroesseCoworkingSubType.PERSON_9_12]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_COWORKING, PrebuildMeetingGroesseCoworkingSubType.PERSON_9_12).average,
      ),
      [PrebuildMeetingGroesseCoworkingSubType.PERSON_13_16]: getFactorWithOriginal(
        getSliderValue(survey, analysis, PrebuildType.MEETING_GROESSE_COWORKING, PrebuildMeetingGroesseCoworkingSubType.PERSON_13_16).average,
      ),
    },
  }
}

export default getFactorValues
